import { Agreement, ContractStatusResponse } from '@codegen';
import {
  AgreementsTypes,
  AgreementsAction,
} from '@modules/agreements/store/agreements.action';

export class AgreementsState {
  public agreementsList: Agreement[];
  public documentsList: Agreement[] | null;
  public additionalInfo: Pick<
    ContractStatusResponse,
    'productCategoryCode' | 'productTypeCode'
  >;
}

export function reducer(
  state = new AgreementsState(),
  action: AgreementsAction
): AgreementsState {
  switch (action.type) {
    case AgreementsTypes.SetAgreementsProposal: {
      return {
        ...state,
        agreementsList: action.payload,
      };
    }
    case AgreementsTypes.SetAgreementsContract: {
      return {
        ...state,
        documentsList: action.payload,
      };
    }
    case AgreementsTypes.SetAdditionalInfoContract: {
      return {
        ...state,
        additionalInfo: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
